const ERROR_TYPES = {
  NETWORK: 'network',           
  RUNTIME: 'runtime',           
  VALIDATION: 'validation',     
  RESOURCE: 'resource',         
  STORAGE: 'storage',           
  MEDIA: 'media',              
  BROWSER: 'browser',          
  PERFORMANCE: 'performance',   
  CONFIGURATION: 'configuration', 
  UNKNOWN: 'unknown'
};

const ERROR_LEVELS = {
  MINOR: 'minor',
  MODERATE: 'moderate',
  CRITICAL: 'critical',
  UNKNOWN: 'unknown'
};

const ERROR_TYPE_PATTERNS = {
  [ERROR_TYPES.NETWORK]: [
    // Network errors
    { pattern: /NetworkError/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Network\s*error/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Network\s*Error/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /NETWORK\s*ERROR/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /fetch.*failed/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Request.*timeout/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Request.*failed/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /\bTimeout\b/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Non-Error promise rejection/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /UnhandledRejection/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Connection.*refused/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Connection.*reset/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /ERR_NETWORK/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /ERR_INTERNET_DISCONNECTED/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /ERR_CONNECTION_TIMED_OUT/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /ERR_CONNECTION_REFUSED/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /ERR_NAME_NOT_RESOLVED/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /ECONNREFUSED/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /ETIMEDOUT/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /ENOTFOUND/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Connection.*unstable/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Intermittent.*connection/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Offline.*mode/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Connection.*slow/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /network|fetch|xhr|cors/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /AbortError/i, criticality: ERROR_LEVELS.MODERATE },
    
    // API errors
    { pattern: /AxiosError/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /getProduct/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /HTTP\s*4\d{2}/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /HTTP\s*5\d{2}/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /HTTPError4\d{2}/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /HTTPError5\d{2}/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /4\d{2}.*error/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /5\d{2}.*error/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Bad Request/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Unauthorized/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Forbidden/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Not Found/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Method Not Allowed/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Conflict/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Internal Server Error/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Bad Gateway/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Service Unavailable/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Gateway Timeout/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /API.*error/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Data.*fetch.*failed/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Failed.*to.*load.*data/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Server.*error/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Service.*error/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Endpoint.*error/i, criticality: ERROR_LEVELS.MODERATE }
  ],

  [ERROR_TYPES.RUNTIME]: [
    // Memory errors
    { pattern: /Maximum call stack size exceeded/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /out of memory/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /RangeError.*Maximum call stack/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Cannot allocate memory/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Stack overflow/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Memory.*warning/i, criticality: ERROR_LEVELS.MODERATE },
    
    // JavaScript errors 
    { pattern: /.*is not a function/i, criticality: ERROR_LEVELS.CRITICAL },
    { pattern: /.*is not defined/i, criticality: ERROR_LEVELS.CRITICAL },
    { pattern: /\w+\.\w+\s+is not a function/i, criticality: ERROR_LEVELS.CRITICAL },
    { pattern: /\w+\s+is not a function/i, criticality: ERROR_LEVELS.CRITICAL },
    { pattern: /getBoundingClientRect.*not.*function/i, criticality: ERROR_LEVELS.CRITICAL },
    { pattern: /ReferenceError/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /TypeError.*undefined/i, criticality: ERROR_LEVELS.CRITICAL },
    { pattern: /TypeError.*null/i, criticality: ERROR_LEVELS.CRITICAL },
    { pattern: /undefined is not an object/i, criticality: ERROR_LEVELS.CRITICAL },
    { pattern: /.*is not an object \(evaluating/i, criticality: ERROR_LEVELS.CRITICAL },
    { pattern: /null is not an object/i, criticality: ERROR_LEVELS.CRITICAL },
    { pattern: /\(evaluating.*\[.*\]\)/i, criticality: ERROR_LEVELS.CRITICAL },
    { pattern: /evaluating\s+'[^']+'/i, criticality: ERROR_LEVELS.CRITICAL },
    { pattern: /undefined is not an object.*\.call/i, criticality: ERROR_LEVELS.CRITICAL },
    { pattern: /null is not an object.*\.call/i, criticality: ERROR_LEVELS.CRITICAL },
    { pattern: /undefined is not an object \(evaluating '[a-z]\.[a-zA-Z_$]+'\)/i, criticality: ERROR_LEVELS.CRITICAL },
  { pattern: /null is not an object \(evaluating '[a-z]\.[a-zA-Z_$]+'\)/i, criticality: ERROR_LEVELS.CRITICAL },
  { pattern: /\(evaluating '[a-z]+\.[a-zA-Z_$]+'\)/i, criticality: ERROR_LEVELS.CRITICAL },
  { pattern: /evaluating.*standardSelectors/i, criticality: ERROR_LEVELS.CRITICAL },
    { pattern: /The object is in an invalid state/i, criticality: ERROR_LEVELS.MODERATE },
  { pattern: /object.*invalid.*state/i, criticality: ERROR_LEVELS.MODERATE },
  { pattern: /Invalid.*object.*state/i, criticality: ERROR_LEVELS.MODERATE },
  { pattern: /Object.*state.*error/i, criticality: ERROR_LEVELS.MODERATE },
  { pattern: /State.*machine.*error/i, criticality: ERROR_LEVELS.MODERATE },
  { pattern: /Illegal.*state/i, criticality: ERROR_LEVELS.MODERATE },
  { pattern: /Invalid.*operation.*state/i, criticality: ERROR_LEVELS.MODERATE },
  { pattern: /The object does not support the operation or argument/i, criticality: ERROR_LEVELS.MODERATE },
{ pattern: /object.*does not support.*operation/i, criticality: ERROR_LEVELS.MODERATE },
{ pattern: /object.*does not support.*argument/i, criticality: ERROR_LEVELS.MODERATE },

    
    // Cannot read properties
    { pattern: /Cannot read propert(y|ies).*of (null|undefined)(?:\s*\(.*\))?/i, criticality: ERROR_LEVELS.CRITICAL },
    { pattern: /Cannot\s+read\s+propert(y|ies)\s+.*\s+of\s+(null|undefined)/i, criticality: ERROR_LEVELS.CRITICAL },
    { pattern: /can't read propert(y|ies).*of (null|undefined)/i, criticality: ERROR_LEVELS.CRITICAL },
    { pattern: /unable to read propert(y|ies).*of (null|undefined)/i, criticality: ERROR_LEVELS.CRITICAL },
    
    { pattern: /Cannot set propert(y|ies).*of (null|undefined)/i, criticality: ERROR_LEVELS.CRITICAL },
    { pattern: /Cannot access.*before initialization/i, criticality: ERROR_LEVELS.CRITICAL },
    { pattern: /Cannot access\s+['"`].*['"`]\s+before initialization/i, criticality: ERROR_LEVELS.CRITICAL },      
    // Syntax errors
    { pattern: /SyntaxError/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Unexpected token/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Unexpected end of input/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Invalid regular expression/i, criticality: ERROR_LEVELS.MODERATE },
    
    // React errors
    { pattern: /React.*render.*error/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Cannot update.*unmounted component/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Invariant Violation/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Minified React error/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /React.*Hook.*called/i, criticality: ERROR_LEVELS.MODERATE }
  ],

  [ERROR_TYPES.VALIDATION]: [
    // Validation errors
    { pattern: /ValidationError/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Invalid.*format/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Required.*field/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Field.*required/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Invalid.*email/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Invalid.*phone/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Invalid.*date/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Invalid.*url/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Password.*requirements/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Validation.*failed/i, criticality: ERROR_LEVELS.MINOR },
    
    // Authentication errors
    { pattern: /Authentication.*failed/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Auth.*error/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Token.*expired/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Token.*invalid/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Session.*expired/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Session.*invalid/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Login.*failed/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Logout.*error/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Permission.*denied/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Access.*forbidden/i, criticality: ERROR_LEVELS.MODERATE },
    
    // Product errors
    { pattern: /^Oa$/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Product.*not.*found/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Product.*missing/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Product.*unavailable/i, criticality: ERROR_LEVELS.MODERATE },

    // Payment errors
    { pattern: /InvalidAccessError/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Payment.*session.*active/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Page.*already.*has.*active.*payment/i, criticality: ERROR_LEVELS.MODERATE }
  ],

  [ERROR_TYPES.RESOURCE]: [
    // Resource loading errors
    { pattern: /Image.*failed.*load/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Video.*failed.*load/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Audio.*failed.*load/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /PDF.*failed.*load/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /File.*failed.*load/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Resource.*failed.*load/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Font.*failed.*load/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Stylesheet.*failed.*load/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Icon.*failed.*load/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Avatar.*failed.*load/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Background.*image.*failed/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Logo.*failed.*load/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Thumbnail.*failed.*load/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Banner.*failed.*load/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Favicon.*error/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Sprite.*failed.*load/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /chunk|loading|script/i, criticality: ERROR_LEVELS.MODERATE },
    
    // Bundle/compilation errors
    { pattern: /Script error/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /ChunkLoadError/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Loading chunk \d+ failed/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Loading CSS chunk \d+ failed/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Failed to import dynamically/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Module not found/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Can't resolve/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Failed to compile/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Build failed/i, criticality: ERROR_LEVELS.MODERATE },
    
    // Security errors (liées aux ressources)
    { pattern: /Content Security Policy/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Mixed Content/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Blocked.*mixed content/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /SecurityError/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /DOMException.*security/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Access.*denied/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Iframe.*access.*denied/i, criticality: ERROR_LEVELS.MODERATE }
  ],

  [ERROR_TYPES.STORAGE]: [
    // Storage errors
    { pattern: /localStorage.*quota/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /sessionStorage.*quota/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Storage.*quota.*exceeded/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Cache.*error/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Cache.*quota/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /IndexedDB.*quota/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /WebSQL.*error/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Storage.*unavailable/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Cookie.*error/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Cookie.*blocked/i, criticality: ERROR_LEVELS.MINOR },
    
    // Database errors
    { pattern: /IndexedDB.*error/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Database.*error/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Transaction.*failed/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Query.*failed/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Connection.*database.*failed/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Connection.*Indexed.*Database.*server.*lost/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /IndexedDB.*connection.*lost/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /IndexedDB.*server.*unavailable/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Database.*connection.*interrupted/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /IDB.*connection.*error/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /ObjectStore.*error/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Database.*version.*error/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Database.*deleted.*by.*request/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Database.*deleted.*by.*user/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /User.*requested.*database.*deletion/i, criticality: ERROR_LEVELS.MINOR },
  ],

  [ERROR_TYPES.MEDIA]: [
    // Geolocation errors
    { pattern: /Geolocation.*denied/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Location.*unavailable/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Position.*unavailable/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /GPS.*error/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Location.*timeout/i, criticality: ERROR_LEVELS.MINOR },
    
    { pattern: /Camera.*disabled/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Camera.*access.*denied/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Camera.*access.*blocked/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Camera.*blocked/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Microphone.*access.*denied/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Media.*access.*denied/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /NotAllowedError/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /NotFoundError.*media/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /NotReadableError/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /OverconstrainedError/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /AbortError.*media/i, criticality: ERROR_LEVELS.MINOR },
    
    // Upload errors
    { pattern: /Upload.*failed/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /File.*upload.*error/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Form.*submission.*failed/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Data.*save.*failed/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Save.*error/i, criticality: ERROR_LEVELS.MODERATE },

    // Audio errors
    { pattern: /Failed.*start.*audio.*device/i, criticality: ERROR_LEVELS.MINOR },
  { pattern: /Audio.*device.*failed/i, criticality: ERROR_LEVELS.MINOR },
  { pattern: /Audio.*device.*unavailable/i, criticality: ERROR_LEVELS.MINOR },
  { pattern: /Audio.*device.*error/i, criticality: ERROR_LEVELS.MINOR },
  { pattern: /Cannot.*start.*audio/i, criticality: ERROR_LEVELS.MINOR },
  { pattern: /Audio.*initialization.*failed/i, criticality: ERROR_LEVELS.MINOR },
  { pattern: /Audio.*stream.*failed/i, criticality: ERROR_LEVELS.MINOR },
  { pattern: /Microphone.*failed.*start/i, criticality: ERROR_LEVELS.MINOR },
  { pattern: /Audio.*context.*failed/i, criticality: ERROR_LEVELS.MINOR },
  { pattern: /getUserMedia.*audio.*failed/i, criticality: ERROR_LEVELS.MINOR },
  ],

  [ERROR_TYPES.BROWSER]: [
    // Browser compatibility errors
    { pattern: /Feature.*not.*supported/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Browser.*compatibility/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /missing features preventing.*from working/i, criticality: ERROR_LEVELS.MODERATE },
{ pattern: /one or more missing features/i, criticality: ERROR_LEVELS.MODERATE },
{ pattern: /OS.*browser.*missing features/i, criticality: ERROR_LEVELS.MODERATE },
{ pattern: /mediaDevices.*not.*supported/i, criticality: ERROR_LEVELS.MODERATE },
{ pattern: /webAssembly.*not.*supported/i, criticality: ERROR_LEVELS.MODERATE },
{ pattern: /MediaDevices.*undefined/i, criticality: ERROR_LEVELS.MODERATE },
{ pattern: /WebAssembly.*undefined/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Polyfill.*warning/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Deprecated.*API/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Legacy.*browser/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Unsupported.*browser/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /IE.*not.*supported/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Notification.*permission/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Notification.*denied/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Push.*notification.*failed/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Share.*API.*not.*supported/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Clipboard.*API.*not.*supported/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Fullscreen.*API.*not.*supported/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Vibration.*API.*not.*supported/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Battery.*API.*not.*supported/i, criticality: ERROR_LEVELS.MINOR },
    
    // Device errors
    { pattern: /Touch.*not.*supported/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Gesture.*not.*supported/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Accelerometer.*error/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Gyroscope.*error/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Orientation.*error/i, criticality: ERROR_LEVELS.MINOR },
    
    // Permission errors
    { pattern: /request.*not.*allowed.*user.*agent/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /request.*not.*allowed.*platform/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /user.*denied.*permission/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Permission.*denied.*user.*agent/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Permission.*denied.*platform/i, criticality: ERROR_LEVELS.MODERATE },
    
    // Browser API compatibility errors
    { pattern: /Can't.*find.*variable.*OffscreenCanvas/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /OffscreenCanvas.*not.*defined/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /OffscreenCanvas.*not.*supported/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Canvas.*API.*not.*supported/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /WebGL.*not.*supported/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /WebGL.*context.*lost/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /WebGL.*error/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Worker.*not.*supported/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /SharedWorker.*not.*supported/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /BroadcastChannel.*not.*supported/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /MessageChannel.*not.*supported/i, criticality: ERROR_LEVELS.MINOR },

    // Extensions errors 
    { pattern: /Can't find variable.*__firefox__/i, criticality: ERROR_LEVELS.MINOR },
{ pattern: /Can't find variable.*__chrome__/i, criticality: ERROR_LEVELS.MINOR },
{ pattern: /__firefox__.*is not defined/i, criticality: ERROR_LEVELS.MINOR },
{ pattern: /__chrome__.*is not defined/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /window\.__firefox__/i, criticality: ERROR_LEVELS.MINOR },
      { pattern: /window\.__chrome__/i, criticality: ERROR_LEVELS.MINOR },
      { pattern: /extension.*not.*available/i, criticality: ERROR_LEVELS.MINOR },
      { pattern: /browser.*extension.*error/i, criticality: ERROR_LEVELS.MINOR },
      { pattern: /window\.ethereum/i, criticality: ERROR_LEVELS.MINOR },
{ pattern: /ethereum.*is not defined/i, criticality: ERROR_LEVELS.MINOR },
{ pattern: /MetaMask.*not.*installed/i, criticality: ERROR_LEVELS.MINOR },
{ pattern: /wallet.*extension.*not.*found/i, criticality: ERROR_LEVELS.MINOR },
{ pattern: /crypto.*wallet.*error/i, criticality: ERROR_LEVELS.MINOR },
{ pattern: /web3.*not.*available/i, criticality: ERROR_LEVELS.MINOR },

      // Renderer process errors
      { pattern: /GPU Process terminated/i, criticality: ERROR_LEVELS.MINOR },
      { pattern: /GPU.*process.*crashed/i, criticality: ERROR_LEVELS.MINOR },
      { pattern: /Renderer.*process.*terminated/i, criticality: ERROR_LEVELS.MINOR },
      { pattern: /Browser.*process.*crashed/i, criticality: ERROR_LEVELS.MODERATE },
      { pattern: /Graphics.*driver.*error/i, criticality: ERROR_LEVELS.MINOR },
      { pattern: /WebGL.*context.*lost/i, criticality: ERROR_LEVELS.MODERATE },
      { pattern: /Hardware.*acceleration.*disabled/i, criticality: ERROR_LEVELS.MINOR },
  ],

  [ERROR_TYPES.PERFORMANCE]: [
    // Performance errors
    { pattern: /Slow.*network/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Performance.*warning/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /CPU.*usage.*high/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Bandwidth.*low/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Lazy.*loading.*failed/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Prefetch.*failed/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Service.*worker.*error/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Background.*sync.*failed/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /newestWorker is null/i, criticality: ERROR_LEVELS.MODERATE },

    // WebSocket errors
    { pattern: /WebSocket.*error/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /WebSocket.*connection.*failed/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Socket.*error/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Connection.*lost/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Connection.*closed/i, criticality: ERROR_LEVELS.MODERATE },
    
    // Service Worker errors
    { pattern: /ServiceWorker.*error/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Failed.*update.*ServiceWorker/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /ServiceWorker.*script.*fetch/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Service.*worker.*update.*failed/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /SW.*registration.*failed/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /ServiceWorker.*registration.*error/i, criticality: ERROR_LEVELS.MODERATE }
  ],

  [ERROR_TYPES.CONFIGURATION]: [
    // Analytics and tracking errors
    { pattern: /Analytics.*failed/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Analytics.*error/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Tracking.*error/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /GTM.*error/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Google.*Analytics.*error/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Facebook.*pixel.*error/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Pixel.*error/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Tag.*Manager.*error/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Hotjar.*error/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Mixpanel.*error/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Segment.*error/i, criticality: ERROR_LEVELS.MINOR },
    
    // Theme and appearance errors
    { pattern: /Theme.*error/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Dark.*mode.*error/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /CSS.*variable.*error/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Style.*error/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Animation.*error/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Transition.*error/i, criticality: ERROR_LEVELS.MINOR },
    
    // Localization and i18n errors
    { pattern: /Translation.*missing/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Locale.*error/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /i18n.*error/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Language.*pack.*failed/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Timezone.*error/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Date.*format.*error/i, criticality: ERROR_LEVELS.MINOR },
    
    // Development and debug errors
    { pattern: /Console.*error/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Debug.*error/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /DevTools.*error/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Source.*map.*error/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Hot.*reload.*error/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /HMR.*error/i, criticality: ERROR_LEVELS.MINOR },
    
    // Plugins and extensions errors
    { pattern: /Plugin.*error/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Extension.*error/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Widget.*error/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Component.*warning/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Library.*warning/i, criticality: ERROR_LEVELS.MINOR },
    
    // SEO and metadata errors
    { pattern: /Meta.*tag.*error/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Open.*Graph.*error/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Schema.*markup.*error/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Sitemap.*error/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Robots.*txt.*error/i, criticality: ERROR_LEVELS.MINOR },
    
    // Configuration errors
    { pattern: /Config.*warning/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Environment.*variable.*missing/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /Feature.*flag.*error/i, criticality: ERROR_LEVELS.MODERATE },
    { pattern: /A\/B.*test.*error/i, criticality: ERROR_LEVELS.MINOR },
    { pattern: /Experiment.*error/i, criticality: ERROR_LEVELS.MINOR }
  ]
};



export { ERROR_TYPE_PATTERNS, ERROR_LEVELS, ERROR_TYPES };